import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const Color      = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow     = Loadable(lazy(() => import('pages/component-overview/shadows')));

const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const Vencidos = Loadable(lazy(() => import('pages/vencidos/vencidos')));
const Clientes   = Loadable(lazy(() => import('pages/clientes/clientes')));
const Rutas      = Loadable(lazy(() => import('pages/rutas/rutas')));
const Usuarios   = Loadable(lazy(() => import('pages/usuarios/usuarios')));
const ComprasDiarios   = Loadable(lazy(() => import('pages/comprasdiarias/comprasdiarios')));
const Pendientes   = Loadable(lazy(() => import('pages/pendientes/pendientes')));
const BaseGeneral   = Loadable(lazy(() => import('pages/baseGeneral/baseGeneral')));
const Bancos   = Loadable(lazy(() => import('pages/bancos/bancos')));
const Bases = Loadable(lazy(() => import('pages/bases/bases')));
const Configuracion  = Loadable(lazy(() => import('pages/configuracion/configuracion')));
const NuevoCredito   = Loadable(lazy(() => import('pages/creditos/NuevoCredito')));
const PendienteHoy   = Loadable(lazy(() => import('pages/pendienteHoy/PendienteHoy')));


const MainRoutes = {
  path: '',                     // <— mueve todo el dashboard bajo /app
  element: <DashboardLayout />,
  children: [
    { index: true, element: <DashboardDefault /> }, // /app
    {
      path: 'dashboard',
      children: [
        { path: 'default', element: <DashboardDefault /> } // /app/dashboard/default
      ]
    },
    { path: 'typography',  element: <Typography /> },
    { path: 'color',       element: <Color /> },
    { path: 'shadow',      element: <Shadow /> },
    { path: 'sample-page', element: <SamplePage /> },
    { path: 'clientes',    element: <Clientes /> },
    { path: 'rutas',       element: <Rutas /> },
    { path: 'usuarios',    element: <Usuarios /> },
    { path: 'compradiarios',    element: <ComprasDiarios /> },
    { path: 'pendientes',    element: <Pendientes /> },
     { path: 'vencidos',    element: <Vencidos /> },
     { path: 'baseGeneral',    element: <BaseGeneral /> },
     { path: 'bancos',    element: <Bancos /> },
     { path: 'bases',    element: <Bases /> },
     { path: 'configuracion',    element: <Configuracion /> },
     { path: 'nuevo-credito',    element: <NuevoCredito /> },
     { path: 'pendiente-hoy',   element: <PendienteHoy /> },
  ]
};

export default MainRoutes;
